import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PopupData } from './popup-data';

@Component({
    selector: 'app-map-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
    @Input() data: PopupData;
    @Output() closePopup: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit(): void {
    }
    onClosePopup(): void {
        this.closePopup.emit();
    }
}



// WEBPACK FOOTER //
// ./libs/map/components/update-popup/popup.component.ts